import { useParams, useSearchParams } from "react-router-dom";
import { ScoreCard } from "../components/PolicyScoreCard";
import { PolicyAction } from "~/operations";
import { policyIcon } from "../utils/policyIcon";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

export type UsePolicyScoreCardProps = {
  scope: SpaceOrWorkspaceScope;
  policyScorecard: ScoreCard;
  isCicd?: boolean;
};

export function usePolicyScoreCard({
  scope,
  policyScorecard,
  isCicd,
}: UsePolicyScoreCardProps) {
  const [searchParams, _setSearchparams] = useSearchParams();
  const { id } = useParams();

  const { __typename, ...rest } = policyScorecard.scoreStats || {};
  const scoreStats = Object.entries(rest)
    .filter(([key, _value]) =>
      ["passed", "failed", "errors", "snoozed", "disabled"].includes(key),
    )
    .map(([key, value]) => {
      if (key === "errors") {
        key = "errorscan";
      }

      return {
        result: key as keyof ScoreCard["scoreStats"],
        value,
      };
    });

  const byMondoo = policyScorecard.title.includes("by Mondoo");
  const policyName = byMondoo
    ? policyScorecard.title.replace(" by Mondoo", "")
    : policyScorecard.title;
  const encodedPolicyMrn = encodeURIComponent(policyScorecard.mrn);

  const policyHref = isCicd
    ? `/space/cicd/jobs/${id}/checks?${scope.params}&policyMrn=${encodedPolicyMrn}&projectId=${searchParams.get(
        "projectId",
      )}&jobId=${searchParams.get("jobId")}`
    : `/space/inventory/${id}/checks?${scope.params}&policyMrn=${encodedPolicyMrn}`;

  const icon = policyIcon(policyScorecard.title);
  const isPreviewMode = policyScorecard.action === PolicyAction.Ignore;

  return {
    icon,
    policyName,
    policyHref,
    byMondoo,
    scoreStats,
    isPreviewMode,
  };
}
